module.exports = __webpack_public_path__ + "img/ranged.716adb4d.svg";